<template>
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar title="Search results"></NavBar>

        <!-- Content -->
        <div class="container search-results">

            <!-- Search -->
            <div>
                <form action="/search-results/" v-on:submit.prevent="submitForm" class="app-form form-inline mt-0">
                    <div class="input-group search">
                        <input id="search-input" type="text" placeholder="Search" :value="searchValue">
                        <span class="input-addon" @click="resetSearch"></span>
                    </div>
                    <button type="submit" class="btn btn-primary px-5">Search</button>
                </form>

                <div v-if="searchError">
                    <div class="alert danger">
                        <p>Please enter at least 3 characters in your search</p> 
                    </div>
                </div>  
                

                <div class="form-inline d-none">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="products">
                        <label class="custom-control-label" for="products">Products</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="trials">
                        <label class="custom-control-label" for="trials">Trials</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="publications">
                        <label class="custom-control-label" for="publications">Publications</label>
                    </div>
                </div>
            </div>

            <!-- No Results -->
            <div class="empty-state" v-if="noSearchResults">
                <h2>No Results Found</h2>
            </div>

            <div> 

                <h2 v-if="filtered.length > 0 || filteredTrials.length > 0" class="results-header">RESULTS</h2> 

                <template v-if="filtered.length > 0">
                    <div class="search-result-item" v-for="product in filtered" :key="product.nid[0].value">
                        <router-link :to="'/timeline/product/'+ product.title[0].value +''"
                                     class="search-result-item__link"
                                     @click.native="trackEvent"
                                     data-category="Search Result Navigation"
                                     data-action="button_press"
                                     :data-event="product.title[0].value"
                        >
                            <span>
                                {{product.title[0].value}} 
                            </span>
                            <img src="img/ui-elements/chevron-right-venous-protection.png">
                        </router-link>
                    </div> 
                </template>

                <template v-if="filteredTrials.length > 0">
                    <div class="search-result-item" v-for="trial in filteredTrials" :key="trial.nid[0].value">
                        <router-link :to="'/trials-two/'+trial.nid[0].value+''"
                                     class="search-result-item__link"
                                     @click.native="trackEvent"
                                     data-category="Search Result Navigation"
                                     data-action="button_press"
                                     :data-event="trial.title[0].value + ' Trial'"
                        >
                            <span>
                                {{trial.title[0].value}} Trial
                            </span>
                            <img src="img/ui-elements/chevron-right-vascular-protection.png">
                        </router-link>
                    </div> 
                </template>
            </div>
        </div>

        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline.png" class="bottom-center">
        </div>
    </div>
</template>

<script>
    import NavBar from './components/NavBar.vue';
    
    export default {
        name: 'SearchResults',
        components: {
            NavBar
        },
        data: function(){
            return {
                noSearchResults: true,
                filtered: [],
                filteredTrials: [],
                searchError: false,
                defaultSearchText: '',
            }
        },
        beforeMount: function() {
            this.completeSearch();
        },
        mounted: function() {
            let previousProductSearch = this.$store.getters.getProductSearch; 
            let previousTrialSearch = this.$store.getters.getTrialSearch; 
            
            if(previousProductSearch.length > 0){ this.filtered = previousProductSearch}
            if(previousTrialSearch.length > 0){ this.filteredTrials = previousTrialSearch} 
            if(previousProductSearch.length > 0 || previousTrialSearch.length > 0) {
                this.noSearchResults = false
            }
        },
        computed: {
            searchValue(){ return this.$store.getters.getSearchTerm == false ? this.defaultSearchText : this.$store.getters.getSearchTerm },
            products(){ return this.$store.getters.allProducts },
            productNames() { return this.$store.getters.getProductNames },
            searchTerm() { return this.$route.params.term },
        },
        methods: {
            resetSearch(event) {
                let parent = event.target.closest('.app-form'); 
                let inp = parent.querySelector('input[type="text"]');
                inp.value =''; 
                inp.focus();
            },
            htmlReplace: function(str) {
                return str.replace(/<(?:.|\n)*?>/gm, '');
            },
            removeQueryFromRoute() {
                this.$router.replace({
                    path: '/search-results/'
                });
            },
            completeSearch: function() {    
                
                this.searchError = false;

                if(!this.$route.params.term) return false;
                
                let searchString = this.searchTerm.toLowerCase(); 

                this.removeQueryFromRoute();

                if(searchString.length < 3){
                    this.searchError =true;
                    this.$store.dispatch('removeSearchResults'); 

                    return false; 
                }
                
                this.storeSearchString(searchString); 

                let names = this.productNames; 
                let trials = this.products;

                const vm = this; 

                let filtered = names.filter( function(el){
                    
                    let str = el.title[0].value.toLowerCase(); 
                    let desc = vm.htmlReplace(el.field_product_description[0].value.toLowerCase()); 

                    if(str.indexOf(searchString) > -1) {
                        return true;  
                    }
                    if(desc.indexOf(searchString) > -1){
                        return true; 
                    }
                   
                    return false; 
                     
                })
                
                this.filtered = this.productIsAllowed(filtered, 'product');


                let filteredTrials = trials.filter( function(el){

                    if(el.type[0].target_id != 'product'){
                        let title = el.title[0].value.toLowerCase(); 
                    
                        if(title.indexOf(searchString) > -1) {
                            return true;
                        }

                        if( el.hasOwnProperty('field_trial_overview') ) {
                            let overview = vm.htmlReplace(el.field_trial_overview[0].value.toLowerCase());  
                                if(overview.indexOf(searchString) > -1) {
                                    return true; 
                            }
                        }
                    }
                    
                    return false; 

                }); 

                this.filteredTrials = this.productIsAllowed(filteredTrials, 'trial'); 

                this.noSearchResults = (this.filtered.length > 0  || this.filteredTrials.length > 0) ? false : true; 

                this.storeResults(); 
            },
            submitForm: function(){
                let el = document.getElementById('search-input'); 
                let searchValue = el.value.toLowerCase(); 

                this.searchError = false; 

                if(searchValue.length < 3){
                    this.searchError =true;
                    this.filtered = []; 
                    this.filteredTrials = [];
                    this.$store.dispatch('removeSearchResults'); 
                    return false; 
                }
                
                this.storeSearchString(searchValue);

                let names = this.productNames; 
                let trials = this.products;
                const vm = this; 

                let filtered = names.filter( function(el){
                    let title = el.title[0].value; 
                    let description = el.field_product_description[0].value; 
                    
                    let str = title.toLowerCase(); 
                    let desc = vm.htmlReplace(description.toLowerCase()); 
                    if(str.indexOf(searchValue) > -1) {
                        return true;  
                    }
                    if(desc.indexOf(searchValue) > -1){
                        return true; 
                    }
                    
                    return false; 
                    
                   
                })
                
                this.filtered = this.productIsAllowed(filtered, 'product');

                let filteredTrials = trials.filter(function(el){

                    if(el.type[0].target_id != 'product'){
                        let title = el.title[0].value.toLowerCase(); 

                        if(title.indexOf(searchValue) > -1) {
                            return true;
                        }

                        if( el.hasOwnProperty('field_trial_overview') ) {
                            let overview = vm.htmlReplace(el.field_trial_overview[0].value.toLowerCase());  
                            if(overview.indexOf(searchValue) > -1) {
                                return true; 
                            }
                        }
                    }
                    return false; 
                }); 

                this.filteredTrials = this.productIsAllowed(filteredTrials, 'trial'); 

                this.noSearchResults = (this.filtered.length > 0  || this.filteredTrials.length > 0) ? false : true; 

                this.storeResults();
            },
            storeSearchString(str) {
                this.$store.dispatch('setSearchTerm', str); 
            },
            storeResults() {
                if(this.filteredTrials) {
                    this.$store.dispatch('setTrialSearchResults', this.filteredTrials); 
                }

                if(this.filtered) {
                    this.$store.dispatch('setProductSearchResults', this.filtered);
                }
            },
            htmlEncodePath: function(path) {
                return encodeURI(path); 
            },
            setImagePath: function(path){
                let p = path; 
                p = this.htmlEncodePath(p);
                return p.replace('public/', '');
            },
            moleculeIsVideo(url) {
                let urlString = url.toLowerCase(); 
                let fileExtension = urlString.substr(-3);
                
                if(fileExtension == 'mp4') {
                    return true;
                }

                return false;
            }, 
            productIsAllowed(results, type) {
                //type will be product or trial 
                var notAllowedItems = window.localStorage.getItem('storageProducts'); 
                let filtered; 
                if(notAllowedItems !== null) {
                    var notAllowed = JSON.parse(notAllowedItems); 
                    //products have been disabled  

                    //product 
                    if(type == 'product') {
                        filtered = results.filter(el => notAllowed.indexOf(el.nid[0].value) < 0 )
                    } else {
                        //node 
                        filtered = results.filter(el => notAllowed.indexOf(el.field_product_list[0].target_id) < 0 );
                    }                    
                } else {
                    return results; 
                }
                
                return filtered;

            },
            trackEvent: function(event) {
                this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
            }
        }
    }
</script>

<style scoped >

    .fs-15 {
        font-size: 15px; 
    }

    .content-container {
        min-height: 100vh;
        overflow: auto;
    }

    .container.search-results {
        overflow-y: auto;
    }

    video {
        max-height: 140px; 
        height: 100%;
    }

    .grid-item.product {
        justify-content: center;
        align-items: center;
    }

    .search-result-image {
        max-width: 160px;
        margin: 0 auto 1em;
    }

    .trial-synopsis {
        font-size: 0.75em;
    }

    .grid-container {
        height: 100%;
        grid-auto-rows: auto; 
        margin-bottom: 30px; 
        max-height: 300px;
    }

    .grid-container.trial-columns {
        grid-template-columns: repeat(auto-fit, minmax(180px, 270px)); 
    }

    .grid-container.trial-columns .grid-item {
        max-height: 180px;
    }

</style> 